import React, { useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Header from "./components/Header";
import { Link, useParams } from "react-router-dom";
import { useGetCustomerOrderHistoryQuery } from "hooks/CustomerManagement/useGetCustomerOrderHistoryQuery";
import { Table, Tag } from "antd";
import Loader from "Components/Loader";
import KoboConverter from "Components/KoboConverter";
import NairaValue from "Components/NairaValue";

const CustomerOrdersPreview = () => {
  const [active, setActive] = useState("all");
  const { id } = useParams();
  const { data, isPending } = useGetCustomerOrderHistoryQuery(`${id}`);

  const columns = [
    {
      title: "Order No",
      dataIndex: "orderNo",
      key: "orderNo",
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Delivery Method",
      dataIndex: "deliveryMethod",
      key: "deliveryMethod",
    },
    {
      title: "Order Status",
      dataIndex: "orderStatus",
      key: "orderStatus",
      render: (status: string) => (
        <Tag
          color={
            status === "paid"
              ? "green"
              : status === "processing"
              ? "blue"
              : "orange"
          }
        >
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Payment Status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (status: string) => (
        <Tag color={status === "paid" ? "green" : "red"}>
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Total Products Amount",
      dataIndex: "totalProductsAmount",
      key: "totalProductsAmount",
      render: (amount: number) => <KoboConverter amount={amount} />,
    },
    {
      title: "Order Products",
      dataIndex: "orderProducts",
      key: "orderProducts",
      render: (orderProducts: any[]) => (
        <ul className="text-[10px]">
          {orderProducts.map((product) => (
            <li key={product.id}>
              {product.productName} - <KoboConverter amount={product.price} />
              (x
              {product.unit}) =
              <KoboConverter amount={product.totalAmount} />
            </li>
          ))}
        </ul>
      ),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string) => new Date(createdAt).toLocaleString(),
    },
  ];

  return (
    <DashboardLayout title="Customer Management" back={false}>
      <Header />
      <div className="flex border-b-[1px] border-[#eeeeee] mb-3">
        <div
          className={`px-[20px] py-[26px] cursor-pointer ${
            active === "all" ? "text-orange bg-primary-light" : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive("all")}
        >
          All Orders ({data.data.meta?.totalDocs})
        </div>
        {/* <div
          className={`px-[20px] py-[26px] cursor-pointer ${
            active === "active"
              ? "text-orange bg-primary-light"
              : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive("active")}
        >
          In Progress (5,900)
        </div>
        <div
          className={`px-[20px] py-[26px] cursor-pointer ${
            active === "del" ? "text-orange bg-primary-light" : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive("del")}
        >
          Delivered (5,900)
        </div>
        <div
          className={`px-[20px] py-[26px] cursor-pointer ${
            active === "suspended"
              ? "text-orange bg-primary-light"
              : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive("suspended")}
        >
          Cancelled (5,900)
        </div> */}
      </div>
      {isPending && <Loader />}
      {data && (
        <Table
          dataSource={data.data.docs}
          columns={columns}
          className="text-[10px]"
          rowClassName="text-[10px]"
          // scroll={{ y: "calc(100vh - 200px)" }}
          // rowKey="id"
          // className="pr-[40px] pl-[20px] flex-grow"
          // loading={isPending}
          // onRow={(record: any) => ({
          //   onClick: () => navigate(`/admin-management/user/${record.id}`),
          // })}
        />
      )}
    </DashboardLayout>
  );
};

export default CustomerOrdersPreview;
